<template>
    <CampLocationTable></CampLocationTable>
</template>
  
  <script>

  import CampLocationTable from "./CampLocationTable.vue"; 

  export default {
    components: {
      CampLocationTable
    }, 
    data() {return{};},
    created() {},
    computed: {},
    methods: {},
  };
  </script>
  
  <style scoped></style>
  